import { useTranslation as baseUseTranslation } from '@valerahealth/ui-translation'
import { UI_COMPONENTS_LOCALS_NAMESPACE } from '../../locales'
/** DONT EXPORT IN PACKAGE. THIS IS INTERNAL ONLY */
export const useTranslation = () => {
  // force ui components to use its own namespace
  return baseUseTranslation(UI_COMPONENTS_LOCALS_NAMESPACE)
}
